<form [formGroup]="formGroup">
  <div class="d-flex flex-column edit-page">
    <div class="d-flex flex-row justify-content-between">
      <div class="d-flex flex-column">
        <span class="title">{{'companyPage.editPage.editProfile'|translate}}</span>
        <span class="required-fields">*{{'companyPage.editPage.required' |translate}}</span>
      </div>
      <mat-icon class="cursor-pointer" (click)="emitClose()">close</mat-icon>
    </div>
    <div class="section">
      <span class="section-title">{{'companyPage.editPage.contactInformation' |translate}}</span>
      <app-input-field [control]="formGroup.controls.emailAddress"
                       class="field-container"
                       [label]="'createUser.email'|translate">
        <input name="emailAddress" formControlName="emailAddress" class="input">
      </app-input-field>
      <app-input-field [control]="formGroup.controls.telephoneNumber"
                       class="field-container"
                       [label]="'createUser.contactInformationForm.phoneNumber'|translate">
        <input name="telephoneNumber" formControlName="telephoneNumber" class="input">
      </app-input-field>
      <app-input-field [control]="formGroup.controls.faxNumber"
                       class="field-container"
                       [label]="'createCompany.contactInformationForm.faxNumber'|translate">
        <input name="faxNumber" formControlName="faxNumber" class="input">
      </app-input-field>
      <app-input-field [control]="formGroup.controls.seatNumber"
                       class="field-container"
                       [label]="'createCompany.contactInformationForm.seatNumber'|translate">
        <input name="seatNumber" formControlName="seatNumber" class="input">
      </app-input-field>
      <div class="d-flex justify-content-between field-container">
        <app-input-field [control]="formGroup.controls.street" class="bigger-input"
                         [label]="'createCompany.addressInformationForm.street'|translate">
          <input name="street" formControlName="street" class="input">
        </app-input-field>

        <app-input-field [control]="formGroup.controls.houseNumber" class="smaller-input"
                         [label]="'createCompany.addressInformationForm.houseNumber'|translate">
          <input name="houseNumber" formControlName="houseNumber" class="input">
        </app-input-field>
      </div>

      <div class="d-flex justify-content-between field-container">
        <app-input-field [control]="formGroup.controls.postalCode" class="smaller-input"
                         [label]="'createCompany.addressInformationForm.postalCode'|translate">
          <input name="postalCode" formControlName="postalCode" type="text" class="input">
        </app-input-field>

        <app-input-field [control]="formGroup.controls.location" class="bigger-input"
                         [label]="'createCompany.addressInformationForm.location'|translate">
          <input name="location" formControlName="location" class="input">
        </app-input-field>
      </div>
      <div class="d-flex justify-content-between field-container">
        <app-input-field [control]="formGroup.controls.countryCode" class="smaller-input"
                         [label]="'createCompany.addressInformationForm.countryCode'|translate">
          <mat-select formControlName="countryCode"
                      [value]="formGroup.value.countryCode"
                      class="input">
            <mat-option *ngFor="let opt of QuestionOptions.countryCodes"

                        [value]="opt">{{opt}}</mat-option>
          </mat-select>
        </app-input-field>

        <app-input-field [control]="formGroup.controls.countryCode" class="bigger-input"
                         [label]="'createCompany.addressInformationForm.country'|translate">
          <mat-select formControlName="countryCode" class="input" [value]="formGroup.value.countryCode">
            <mat-option *ngFor="let opt of QuestionOptions.countryCodes"
                        [value]="opt">{{'countryCodes.' + opt | translate}}</mat-option>
          </mat-select>
        </app-input-field>
      </div>
    </div>
    <div class="section">
      <span class="section-title">{{'companyPage.editPage.aboutUs' |translate}}</span>
      <app-input-field [control]="formGroup.controls.description" class="field-container"
                       [label]="'companyPage.description'|translate">
      <textarea name="description"
                cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"
                formControlName="description" class="input input-text-area"> </textarea>
      </app-input-field>
    </div>
    <div class="buttons">
      <button (click)="emitClose()" class="blue-border">{{'cancel'|translate}}</button>
      <button (click)="submit()" class="blue-content">{{"save"|translate}}</button>
    </div>
  </div>
</form>
